import { z } from 'zod';
import { requiredString } from '../helpers';
export const Egain_Handoff_1_ConfigValidator = z.object({
    connection: requiredString('eGain Connection is required'),
    entryPointId: requiredString('Entry Point ID is required'),
    lookupContactBy: z.enum(['email', 'phone']).nullable().optional(),
    customerName: z.string().optional(),
    customerEmail: z.string().optional(),
    customerPhone: z.string().optional(),
    caseName: z.string().optional()
});
//# sourceMappingURL=egain-handoff-1.js.map